module.exports = __webpack_public_path__ + "static/scholartree_white_logo.a2db4cb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/experience/scholartree_white_logo.svg
// module id = 485
// module chunks = 35783957827783